import { createContext } from "react";

export const CardContext = createContext({
    pdf_link: "",
    status: "",
    tipo_card: "",
});
